import ViewManager from './managers/view';
ViewManager.activate(); // Activate the view manager up before components are initialised

import 'url-search-params-polyfill';
import { initLazy } from './util/transitions';
import { website } from './components/modules/Lagacy/init';
import Blazy from './managers/blazy';
import Device from './managers/device'; // Ignore not using warning. It initialises itself.
import delayPageTransitions from './util/delayPageTransitions';
import * as components from './components';
import * as Sentry from '@sentry/browser';
import { dsn, release, environment } from './constants/sentry';
import HubspotScraper from './components/modules/HubspotScraper';


if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const friendlyName = process.env.USERNAME || 'unknown';

// Ensure sentryDsn has been switched correctly before init, this deactivates
// sentry if no sentryDsn is provided
if (dsn.indexOf('@sentry.io') > -1 ) {
  Sentry.init({ dsn, release, environment });
}
Sentry.configureScope((scope) => {
  scope.setUser({ username: friendlyName });
});

// Set the flag to show the JS is loaded
window.isJsLoaded = true;

// delay page transitions using class on body
delayPageTransitions();

// listen for class changes on body to force loading of images via Blazy
const bodyElement = document.body;
const cssLoadingClass = 'css-loading';

if (bodyElement.classList.contains(cssLoadingClass)) {
  const bodyObserver = new MutationObserver((mutations) => {
    [...mutations].forEach((mutation) => {
      if (mutation.attributeName === 'class' && !bodyElement.classList.contains(cssLoadingClass)) {
        initLazy();
        let bLazy = Blazy;
        Blazy.revalidate();
        ViewManager.invalidate();
      }
    });
  });

  bodyObserver.observe(bodyElement, { attributes: true });
} else {
  initLazy();
  let bLazy = Blazy;
  ViewManager.invalidate();
}

// Accept hot module reloading
if (module.hot) module.hot.accept();


// create instance of Hubspot class to scan through document for all Hubspot links,
// on click of each will bring up a hubspot form
new HubspotScraper();

[...document.querySelectorAll('[data-component]')].forEach((element) => {
  const componentName = element.getAttribute('data-component');

  const isValidName = Object.prototype.hasOwnProperty.call(components, componentName);
  if (!isValidName) {
    console.error(`Invalid component: ${componentName}`);
    return;
  }

  const isValidConstructor = typeof components[componentName] === 'function';
  if (!isValidConstructor) {
    console.error(`Invalid constructor: ${componentName}`);
    Sentry.captureException(`Invalid constructor: ${componentName}`);
    return;
  }
  try {
    return new components[componentName](element);
  }
  catch (e) {
    console.error(e);
  }
});

website();
